/** UI copy of the 404 page (Figma 60325:22189) – the core dictionary has no matching strings. */
export const NOT_FOUND_COPY = {
  code: '404',
  title: 'Táto stránka neexistuje',
  text: 'Odkaz je možno neplatný alebo produkt už nepredávame. Skúste vyhľadávanie alebo pokračujte na niektorú z kategórií nižšie.',
  searchPlaceholder: 'Čo hľadáte? Napr. hmoždinky, Dergall…',
  home: 'Na domovskú stránku',
  support: 'Kontaktovať podporu',
  suggestions: 'Možno hľadáte',
} as const;
